<template>
    <p class="text-sm text-gray-500 dark:text-gray-200 leading-6">
        <span
            v-if="icon || iconModule"
            class="inline-block mr-1">
            <Icon
                :name="icon"
                :module="iconModule" />
        </span>
        <slot>
            {{ displayedContent }} <a
                v-if="expansionPossible && !expanded"
                href="#"
                class="text-primary hover:underline"
                @click.prevent
                @click="expanded = true">{{ $t('showMore') }}</a>
        </slot>
    </p>
</template>

<script setup lang="ts">
const {content, icon, expandable = false} = defineProps<{
    content?: string,
    icon?: string,
    iconModule?: string,
    expandable?: boolean
}>()

const expanded = ref(false)
const threshold = 100 // Character limit for expansion

const expansionPossible = computed(() => {
    return expandable && (content?.length ?? 0) > threshold
})

const displayedContent = computed(() => {
    if (expanded.value || !expansionPossible.value || !content) return content
    return content?.length > threshold ? content.slice(0, threshold) + '...' : content
})
</script>